import React from 'react';
import { Route, Switch } from 'react-router';
import asyncComponent from './components/AsyncComponent';

const Layout = asyncComponent(() => import("./components/Layout"));
const Requests = asyncComponent(() => import("./components/Requests"));
const Login = asyncComponent(() => import("./components/Login"));
const TakeLogin = asyncComponent(() => import("./components/TakeLogin"));
const TelegramUsers = asyncComponent(() => import("./components/TelegramUsers"));
const TelegramUserEdit = asyncComponent(() => import("./components/TelegramUserEdit"));
const Settings = asyncComponent(() => import("./components/Settings"));
const RequestView = asyncComponent(() => import("./components/RequestView"));


export default () => (
    <Layout>
        <Switch>
            <Route exact path='/' component={TakeLogin} />
            <Route path='/admin' component={Requests} />
            <Route path='/login' component={Login} />
            <Route path='/request/:id?'component={RequestView} />
            <Route path='/telegram/:type/:id?' component={TelegramUserEdit} />
            <Route path='/telegram' component={TelegramUsers} />
            <Route path='/settings' component={Settings} />
        </Switch>
    </Layout>
);